import {tracking} from "@bark/bark-core";

/**
 * @typedef CreditsUsedObject
 * @property {Number} projectResponseId
 * @property {Number} creditsUsed
 * @property {Boolean} canRequestReturn
 * @property {Boolean} hasRequestedReturn
 * @property {String} returnStatus
 */

export function CreditsUsed() {
	const Bark = window.Bark = window.Bark || {};
	const seller = Bark.seller = Bark.seller || {};
	const CreditsUsed = seller.CreditsUsed = seller.CreditsUsed || {};

	let Dispatcher;

	CreditsUsed.render = (/** CreditsUsedObject */ creditsUsed) => {
		const container = $('#_credits-used-container');

		if (Dispatcher && container.children().length) {
			try {
				Dispatcher({
					type: 'setProjectResponseId',
					value: Number(creditsUsed.projectResponseId),
				});
				Dispatcher({
					type: 'setCreditsUsed',
					value: creditsUsed.creditsUsed,
				});
				Dispatcher({
					type: 'setCanRequestReturn',
					value: Boolean(creditsUsed.canRequestReturn),
				});
				Dispatcher({
					type: 'setHasRequestedReturn',
					value: Boolean(creditsUsed.hasRequestedReturn),
				});
				Dispatcher({
					type: 'setReturnStatus',
					value: creditsUsed.returnStatus,
				});
			} catch (e) {}
		} else {
			if (window.SellerResponsesApp) {
				window.SellerResponsesApp.launchModule(
					'creditsUsed',
					'_credits-used-container',
					{
						projectResponseId: creditsUsed.projectResponseId,
						creditsUsed: creditsUsed.creditsUsed,
						canRequestReturn: creditsUsed.canRequestReturn,
						hasRequestedReturn: creditsUsed.hasRequestedReturn,
						returnStatus: creditsUsed.returnStatus,
						onMount: dispatcher => {
							Dispatcher = dispatcher;
						},
					},
				);
			} else {
				tracking(
					'seller-leads-dashboard-&-responses',
					'Seller responses react app not loaded',
				);
			}
		}
	}
}
